/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensalidadesAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_MENSALIDADES = 'fetch-mensalidades',
  FIELD_DT_FIM = 'field-dt-fim',
  FIELD_DT_INICIO = 'field-dt-inicio',
  FIELD_NOTA_FISCAL = 'field-nota-fiscal',
  FIELD_PAGADOR = 'field-pagador',
  FIELD_TITULO = 'field-titulo',
  FIELD_TITULO_MOBILE = 'field-titulo-mobile',
  FIELD_TOTAL = 'field-total',
  FIELD_VENCIMENTO = 'field-vencimento',
  FILTER_MENSALIDADES = 'filter-mensalidades',
  FILTERED_LIST = 'filtered-list',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  PANEL_MAIN = 'panel-main',
  TEXT_0 = 'text-0',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_TITULO = 'text-titulo',
  TEXT_TITULO_MOBILE = 'text-titulo-mobile',
}
export { MensalidadesAliases };
